// extracted by css-extract-rspack-plugin
export default {"root":"root-Ckg9o8"};